module.exports = __webpack_public_path__ + "mp.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mp.svg
// module id = 954
// module chunks = 0